import React, { useState } from "react";
import { useScrollPosition } from "../hooks/useScrollPosition";
import useResizeObserver from "../hooks/useResizeObserver";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { NavLink } from "./home/migration";

const Navigation = React.forwardRef((props, ref) => {
  const { content, language, onLanguageChange, navLabels } = props;
  const { mainBody, repos, about, skills, testimonials, portfolios, experiences } =
    content;
  const [isTop, setIsTop] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navbarMenuRef = React.useRef();
  const navbarDimensions = useResizeObserver(navbarMenuRef);
  const navBottom = navbarDimensions ? navbarDimensions.bottom : 0;
  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (!navbarDimensions) return;
      currPos.y + ref.current.offsetTop - navbarDimensions.bottom > 5
        ? setIsTop(true)
        : setIsTop(false);
      setScrollPosition(currPos.y);
    },
    [navBottom]
  );

  React.useEffect(() => {
    if (!navbarDimensions) return;
    navBottom - scrollPosition >= ref.current.offsetTop
      ? setIsTop(false)
      : setIsTop(true);
  }, [navBottom, navbarDimensions, ref, scrollPosition]);

  return (
    <Navbar
      ref={navbarMenuRef}
      className={`px-3 fixed-top  ${!isTop ? "navbar-white" : "navbar-transparent"
        }`}
      expand="lg"
    >
      <Navbar.Brand className={`navbar-brand ${isTop ? "text-color" : ""}`} href={process.env.PUBLIC_URL + "/#home"}>
        {`<${mainBody.firstName} />`}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="toggler" />
      <Navbar.Collapse id="basic-navbar-nav" className="w-100">
        <Nav className="navbar-nav">
          {/* {
            <NavLink className="nav-item lead">
              <Link to={process.env.PUBLIC_URL + "/blog"}>Blog</Link>
            </NavLink>
          } */}
          {repos.show && (
            <NavLink
              className={`${isTop ? "text-color" : ""}`}
              href={process.env.PUBLIC_URL + "/#projects"}
            >
              {navLabels.projects}
            </NavLink>
          )}
           {portfolios.show && (
            <NavLink
              className={`nav-item lead ${isTop ? "text-color" : ""}`}
              // className="nav-item lead text-color"
              href={process.env.PUBLIC_URL + "/#portfolios"}
            >
              {navLabels.portfolios}
            </NavLink>
          )}
          <NavLink
          className={`nav-item lead ${isTop ? "text-color" : ""}`}
            // className="nav-item lead text-color"
            href={about.resume}
            target="_blank"
            rel="noreferrer noopener"
          >
            {navLabels.resume}
          </NavLink>
          {about.show && (
            <NavLink
              className={`nav-item lead ${isTop ? "text-color" : ""}`}
              // className="nav-item lead text-color"
              href={process.env.PUBLIC_URL + "/#aboutme"}
            >
              {navLabels.about}
            </NavLink>
          )}
          {skills.show && (
            <NavLink
              className={`nav-item lead ${isTop ? "text-color" : ""}`}
              // className="nav-item lead text-color"
              href={process.env.PUBLIC_URL + "/#skills"}
            >
              {navLabels.skills}
            </NavLink>
          )}
          {experiences.show && (
            <NavLink
              className={`nav-item lead ${isTop ? "text-color" : ""}`}
              // className="nav-item lead text-color"
              href={process.env.PUBLIC_URL + "/#experiences"}
            >
              {navLabels.experiences}
            </NavLink>
          )}
          {testimonials.show && (
            <NavLink
              className={`nav-item lead ${isTop ? "text-color" : ""}`}
              // className="nav-item lead text-color"
              href={process.env.PUBLIC_URL + "/#testimonials"}
            >
              {navLabels.testimonials}
            </NavLink>
          )}
        </Nav>
        <div className="language-switcher d-flex align-items-center mt-3 mt-lg-0">
          <button
            type="button"
            className={`language-toggle ${isTop ? "language-toggle-light" : "language-toggle-dark"}`}
            onClick={() => onLanguageChange(language === "en" ? "pt-BR" : "en")}
            aria-label="Change language"
          >
            <span className={`language-option ${language === "en" ? "active" : ""}`}>
              EN
            </span>
            <span className={`language-option ${language === "pt-BR" ? "active" : ""}`}>
              PT-BR
            </span>
          </button>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
});

export default Navigation;
